import { render, staticRenderFns } from "./MobileCaseList.vue?vue&type=template&id=10eb4b97"
import script from "./MobileCaseList.vue?vue&type=script&lang=js"
export * from "./MobileCaseList.vue?vue&type=script&lang=js"
import style0 from "./MobileCaseList.vue?vue&type=style&index=0&id=10eb4b97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports